/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Preferences_SavedInputs */

const en_user_preferences_saved = /** @type {(inputs: User_Preferences_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User preferences saved`)
};

const es_user_preferences_saved = /** @type {(inputs: User_Preferences_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferencias de usuario guardadas`)
};

/**
* | output |
* | --- |
* | "User preferences saved" |
*
* @param {User_Preferences_SavedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const user_preferences_saved = /** @type {((inputs?: User_Preferences_SavedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Preferences_SavedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_preferences_saved(inputs)
	return es_user_preferences_saved(inputs)
});